import surveySagas from './survey';
import surveysSagas from './surveys';

export default [...surveySagas, ...surveysSagas];
